import ApiCalls from "../../api";
import { ContactStoreActions } from "../../redux/contacts-store";
import { store } from "../../redux/store";

const ContactHelper = {
  createNewContact: async ({ name, phone, email, preferredPlatform }) => {
    const contactData = {
      of: "unknown",
      name,
    };
    
    const platforms = [];

    if (phone) {
      platforms.push({ on: "whatsapp", referenceId: `whatsapp:${phone}` });
      contactData.phone = phone;
    }

    if (email) {
      platforms.push({ on: "email", referenceId: email });
      contactData.email = email;
    }

    if (platforms.length > 0) {
      // set default platform
      if (preferredPlatform) {
        contactData.platforms = platforms.map((p) => ({ ...p, isDefault: p.on === preferredPlatform }));
      } else if (platforms.length === 1) {
        contactData.platforms = platforms.map((p) => ({ ...p, isDefault: true }));
      } else {
        // both present but no explicit preference: default to whatsapp if exists else first
        contactData.platforms = platforms.map((p, idx) => ({ ...p, isDefault: p.on === "whatsapp" || idx === 0 }));
      }
    }
    
    const response = await ApiCalls.contact.private.createContact(contactData);
    return {
      contactId: response?.data?.data?._id || null,
    };
  },
  fetchAllContacts: async () => {
    const {data} = await ApiCalls.contact.private.getContacts();
    if (data?.data?.docs) {
      store.dispatch(ContactStoreActions.setContacts(data.data.docs));
    }

  },
  getContactDetails: async (contactId) => {
    const response = await ApiCalls.contact.private.getContactDetails(contactId);
    return response?.data?.data || null;
  },
  updateContact: async (contactId, updates) => {
    const response = await ApiCalls.contact.private.updateContact(contactId, updates);
    return response?.data?.data || null;
  },
  deleteContact: async (contactId) => {
    const response = await ApiCalls.contact.private.deleteContact(contactId);
    return response?.data?.data || null;
  },
  checkContactExists: async ({ email, phone }) => {
    const response = await ApiCalls.contact.private.checkIfContactExists({ email, phone });
    return response?.data?.data || null;
  },
};

export default ContactHelper;
